import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { injectIntl as withIntl } from 'react-intl';
import { Link } from 'gatsby';
import routing from '../../services/routing';
import useCampaignProps from '../hooks/campaignProps';
import Content from '../components/Content';
export default withIntl(function (_ref) {
  var intl = _ref.intl,
      props = _objectWithoutPropertiesLoose(_ref, ["intl"]);

  var campaignProps = useCampaignProps(intl);
  return React.createElement(Content, Object.assign({}, props, {
    cardProps: {
      CampaignCard: Object.assign({}, campaignProps),
      NodesCard: {
        wrapItemElement: function wrapItemElement(elem, _ref2) {
          var node = _ref2.node;
          return React.createElement(Link, {
            to: routing.getPath(node)
          }, elem);
        },
        nodeFragment: "\n            fragment NodeFields on Node {\n              resourceType\n              locale {\n                id\n                name\n                primary\n              }\n            }\n          "
      }
    }
  }));
});